const DEFAULT_BASE = "/api";

export function getApiBase(): string {
  const env = (import.meta as any)?.env;
  const explicit = (env?.VITE_API_BASE_URL as string) || "";
  if (explicit) return explicit.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const { hostname, port } = window.location;
    const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
    if (isLocalHost && (port === "4173" || port === "5173")) {
      // Prefer Vite proxy for same-origin cookies during local demos.
      return "/api";
    }
    if (isLocalHost && port === "3001") {
      // Docker frontend -> backend on localhost:8787 in local dev.
      return "http://localhost:8787/api";
    }
  }
  return DEFAULT_BASE;
}

export function withApiBase(path: string): string {
  if (!path) return getApiBase();
  if (/^https?:\/\//i.test(path)) return path;
  const base = getApiBase().replace(/\/$/, "");
  return path.startsWith("/") ? `${base}${path}` : `${base}/${path}`;
}
